import React from 'react'
import { CircleAction } from '../utils/action/Action'
import { BLUE, RED } from '../../utils/colors'
import { ControlButtonProps } from './types'

export const ButtonClose = ({active, onPress}: ControlButtonProps) => <CircleAction active={true} label="Sair" color={RED} icon="x" onPress={onPress} />

